import type { FilterState } from './store';
import type { FilterEnabledSlugs, marketplaceEntityFilterFieldNames } from './types';

// Organic filter enabled slugs
export const FILTER_ENABLED_SLUGS: FilterEnabledSlugs[] = [
  'cd-rates',
  'bank-bonuses-and-promotions',
];

// For Paid, used to display the location filter + sort by
export const PAID_GEO_TARGETED_FILTER_SLUG =
  'paid-geo-targeted' as const satisfies FilterEnabledSlugs;

export const PAID_FILTER_ENABLED_SLUG_OVERRIDES: Partial<Record<string, FilterEnabledSlugs>> = {};

export const PAID_FILTER_ENABLED_SLUG_PREFIXES = [
  { prefix: 'standout-cd-rates', filterSlug: 'cd-rates' },
] as const satisfies readonly { prefix: string; filterSlug: FilterEnabledSlugs }[];

export const LABEL_TO_PRODUCT_TYPES = {
  'Checking Account': 'CHECKING',
  'Savings Account': 'SAVINGS',
};

export const SLUGS_WITH_LOCATION_FILTER = ['bank-bonuses-and-promotions'];

export const TERM_LENGTH_RANGES = [
  { min: 0, max: 180, label: '3 - 6 Months' },
  { min: 181, max: 360, label: '7 - 12 Months' },
  { min: 361, max: 1080, label: '13 Months - 3 Years' },
  { min: 1081, max: Infinity, label: '3+ Years' },
];

export const MIN_DEPOSIT_RANGES = [
  { min: 0, max: 499, label: '$0 - $499' },
  { min: 500, max: 999, label: '$500 - $999' },
  { min: 1000, max: 1499, label: '$1000 - $1499' },
  { min: 1500, max: 2999, label: '$1500 - $2999' },
  { min: 3000, max: Infinity, label: '$3000+' },
];

export const MIN_BALANCE_RANGES = [
  { min: 0, max: 0.99, label: 'No Minimum' },
  { min: 1, max: 99, label: '$1 - $99' },
  { min: 100, max: 499, label: '$100 - $499' },
  { min: 500, max: Infinity, label: '$500+' },
];

export const BONUS_OPTIONS = [
  { label: 'Bonus', value: 'Bonus' },
  { label: 'No Bonus', value: 'No Bonus' },
];

export const rangeOptionsByField: Record<
  marketplaceEntityFilterFieldNames,
  { min: number; max: number; label: string }[]
> = {
  minimumBalance: MIN_DEPOSIT_RANGES,
  cdDepositTerm: TERM_LENGTH_RANGES,
};

export const FILTER_PAIR_MAP = {
  cdDepositTerm: {
    peerMarketplaceKey: 'minimumBalance',
    peerFilterKey: 'selectedMinDepositRanges',
  },
  minimumBalance: {
    peerMarketplaceKey: 'cdDepositTerm',
    peerFilterKey: 'selectedTermRanges',
  },
} as const satisfies Record<
  marketplaceEntityFilterFieldNames,
  {
    peerMarketplaceKey: marketplaceEntityFilterFieldNames;
    peerFilterKey: keyof FilterState;
  }
>;
